import React from 'react';
import CreateRuleGroupLayout from './CreateRuleGroupLayout';

const CreateRuleGroupPage = () => {
    return <CreateRuleGroupLayout />;
};

export default CreateRuleGroupPage;
